import { motion } from "framer-motion"
import { Link } from "gatsby"
import React from "react"

export default function LinkedButton({ path, label, filled }) {
  let cName = filled ? "button-filled" : "button-outlined"
  return (
    <Link to={path}>
      <motion.button
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        className={cName}
      >
        {label}
      </motion.button>
    </Link>
  )
}
